import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { StoreModule } from '@ngrx/store';
import { languageReducer, languageFeatureKey } from './state/language.reducer';
import { EffectsModule } from '@ngrx/effects';
import { LanguageEffects } from './state/language.effects';



@NgModule({
  declarations: [],
  imports: [
    CommonModule,
    StoreModule.forFeature(languageFeatureKey, languageReducer), 
    EffectsModule.forFeature([LanguageEffects])
  ]
})
export class LanguageModule { }
